import { reactive } from 'vue'

export interface ConfirmOpciones {
  titulo: string
  mensaje?: string
  confirmar?: string
  cancelar?: string
  /** Botón rojo para acciones destructivas. */
  peligroso?: boolean
}

interface Estado extends Required<ConfirmOpciones> {
  visible: boolean
  resolver: ((valor: boolean) => void) | null
}

// Singleton: un solo diálogo montado en App.vue atiende a toda la app.
const estado = reactive<Estado>({
  visible: false,
  titulo: '',
  mensaje: '',
  confirmar: 'Confirmar',
  cancelar: 'Cancelar',
  peligroso: false,
  resolver: null,
})

/**
 * Reemplazo del `confirm()` del navegador con el estilo de la app.
 *
 *   const ok = await confirmar({ titulo: '¿Eliminar?', peligroso: true })
 */
export function useConfirm() {
  function confirmar(opciones: ConfirmOpciones): Promise<boolean> {
    // Si había uno abierto, se cancela para no dejar una promesa colgada.
    estado.resolver?.(false)
    estado.titulo = opciones.titulo
    estado.mensaje = opciones.mensaje ?? ''
    estado.confirmar = opciones.confirmar ?? 'Confirmar'
    estado.cancelar = opciones.cancelar ?? 'Cancelar'
    estado.peligroso = opciones.peligroso ?? false
    estado.visible = true
    return new Promise<boolean>((resolve) => {
      estado.resolver = resolve
    })
  }

  function responder(valor: boolean) {
    estado.visible = false
    const r = estado.resolver
    estado.resolver = null
    r?.(valor)
  }

  return { estado, confirmar, responder }
}
